import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import Button from '@panneau/element-button';
import Link from '@panneau/element-link';

var propTypes = {
  brand: PropTypes.node,
  brandLink: PropTypes.string,
  breadcrumbs: PropTypes.node,
  theme: PropTypes.oneOf(['light', 'dark', 'primary', null]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  compact: PropTypes.bool,
  noWrap: PropTypes.bool,
  withoutCollapse: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  collapseClassName: PropTypes.string,
  brandClassName: PropTypes.string,
  breadCrumbsClassName: PropTypes.string
};
var defaultProps = {
  brand: null,
  brandLink: null,
  breadcrumbs: null,
  theme: null,
  size: 'md',
  compact: false,
  noWrap: false,
  withoutCollapse: false,
  children: null,
  className: null,
  collapseClassName: null,
  brandClassName: null,
  breadCrumbsClassName: null
};
var Navbar = function Navbar(_ref) {
  var brand = _ref.brand,
    brandLink = _ref.brandLink,
    breadcrumbs = _ref.breadcrumbs,
    theme = _ref.theme,
    size = _ref.size,
    compact = _ref.compact,
    noWrap = _ref.noWrap,
    withoutCollapse = _ref.withoutCollapse,
    children = _ref.children,
    className = _ref.className,
    collapseClassName = _ref.collapseClassName,
    brandClassName = _ref.brandClassName,
    breadCrumbsClassName = _ref.breadCrumbsClassName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuVisible = _useState2[0],
    setMenuVisible = _useState2[1];
  var onClickMenu = useCallback(function () {
    return setMenuVisible(!menuVisible);
  }, [setMenuVisible, menuVisible]);
  return /*#__PURE__*/React.createElement("nav", {
    className: classNames(['navbar', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "bg-".concat(theme), theme !== null), "navbar-expand-".concat(size), !withoutCollapse), "navbar-".concat(theme === 'light' ? 'light' : 'dark'), theme !== null), "text-".concat(theme === 'light' ? 'dark' : 'light'), theme !== null), 'py-2', compact), 'px-2', compact), 'flex-nowrap', noWrap), className, className !== null)])
  }, brand !== null && brandLink !== null ? /*#__PURE__*/React.createElement(Link, {
    className: classNames(['navbar-brand', _defineProperty({
      'py-0': compact
    }, brandClassName, brandClassName !== null)]),
    href: brandLink
  }, brand) : null, brand !== null && brandLink === null ? /*#__PURE__*/React.createElement("span", {
    className: classNames(['navbar-brand', _defineProperty({
      'py-0': compact
    }, brandClassName, brandClassName !== null)])
  }, brand) : null, breadcrumbs !== null ? /*#__PURE__*/React.createElement("span", {
    className: classNames(['navbar-breadcrumbs', _defineProperty({
      'py-0': compact
    }, breadCrumbsClassName, breadCrumbsClassName !== null)])
  }, breadcrumbs) : null, !withoutCollapse ? /*#__PURE__*/React.createElement(Button, {
    className: "navbar-toggler",
    onClick: onClickMenu,
    withoutTheme: true,
    "aria-controls": "navbarSupportedContent",
    "aria-expanded": "false",
    "aria-label": "Toggle navigation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "navbar-toggler-icon"
  })) : null, !withoutCollapse ? /*#__PURE__*/React.createElement("div", {
    className: classNames(['navbar-collapse', 'collapse', _defineProperty({
      show: menuVisible
    }, collapseClassName, collapseClassName !== null)])
  }, children) : children);
};
Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;

export { Navbar as default };
